import { Box } from "@mui/material";
import ReactSelect from "react-select";
import styles from "./styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";

interface Props {
  className?: string;
  pageCount: any;
  pageIndex: number;
  gotoPage: (page: number) => void;
  rows?: any;
  pageText?: any;
}

const Pagination = ({
  pageIndex,
  gotoPage,
  rows,
  pageCount,
  pageText,
}: Props) => {
  pageCount = parseInt(pageCount);
  const canGoNextPage = pageIndex < pageCount - 1;
  const canGoPreviousPage = pageIndex > 0;

  function goToPreviousPage() {
    gotoPage(pageIndex - 1);
  }

  function goToNextPage() {
    gotoPage(pageIndex + 1);
  }

  const tempPagesList = Array.from(
    { length: pageCount },
    (_, index) => index + 1
  ).map((item) => {
    return { value: item, label: `${item}` };
  });

  return pageCount > 1 ? (
    <Box sx={styles.StyledPagination}>
      <Box
        component={"button"}
        onClick={goToPreviousPage}
        disabled={!canGoPreviousPage}
        className="navigate nav_previous"
      >
        <ArrowBackIosIcon /> {pageText?.textMetadata?.previous}
      </Box>
      <div className="pages">
        {pageCount <= 2 && pageCount > 1 && (
          <>
            {Array(2)
              .fill(null)
              .map((_, index) => (
                <button
                  className={pageIndex === index ? " active" : ""}
                  key={index}
                  onClick={() => gotoPage(index)}
                >
                  {index + 1}
                </button>
              ))}
          </>
        )}
        {pageCount > 2 && (
          <>
            <button
              className={pageIndex === 0 ? "active" : ""}
              onClick={() => gotoPage(0)}
            >
              1
            </button>
            {pageIndex > 2 && <span>&hellip;</span>}
            {pageIndex > 1 && (
              <button onClick={goToPreviousPage}>{pageIndex}</button>
            )}
            {pageIndex > 0 && pageIndex < pageCount - 1 && (
              <span className="active">{pageIndex + 1}</span>
            )}
            {pageIndex < pageCount - 2 && (
              <button onClick={goToNextPage}>{pageIndex + 2}</button>
            )}
            {pageIndex < pageCount - 3 && <span>&hellip;</span>}
            <button
              className={pageIndex === pageCount - 1 ? "active" : ""}
              onClick={() => gotoPage(pageCount - 1)}
            >
              {pageCount}
            </button>
          </>
        )}
        <Box sx={styles.jumpTo}>
          <Box className="label"> {pageText?.textMetadata?.jumpto}: </Box>
          <Box>
            <ReactSelect
              classNamePrefix={"pages_list"}
              onChange={(e: any) => {
                gotoPage(Number(e.value - 1));
              }}
              value={{ value: pageIndex, label: `${pageIndex + 1}` }}
              className={"react-select"}
              options={tempPagesList}
            />
          </Box>
        </Box>
      </div>
      <Box
        component={"button"}
        onClick={goToNextPage}
        disabled={!canGoNextPage}
        className="navigate nav_next"
      >
        {pageText?.buttonsMetadata?.nextButtonText}{" "}
        <ArrowForwardIosOutlinedIcon />
      </Box>
    </Box>
  ) : (
    <></>
  );
};

export default Pagination;
